import { Select } from "../survey";

/**
 * Checks for duplicate values within the same Select.
 */
export const noDuplicateSelectValuesRule = (select: Readonly<Select>) => {
  const uniqueSelectValues = new Set<string>();
  for (const option of select.choices) {
    if (uniqueSelectValues.has(option.value)) {
      return { passed: false, message: `Duplicate Select value "${option.value}" for target field "${select.targetField}"` };
    }
    uniqueSelectValues.add(option.value);
  }
  return { passed: true };
}
